module.exports = __webpack_public_path__ + "static/media/sound_warning.362c7f81.mp3";